module.exports = __webpack_public_path__ + "static/media/cloudUpload.6260b4a6.svg";